import { render } from "./AgeTable.vue?vue&type=template&id=6866926f"
import script from "./AgeTable.vue?vue&type=script&lang=js"
export * from "./AgeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__